import { type licenseProductForm_LicenseProductFragment$key } from "@relay/licenseProductForm_LicenseProductFragment.graphql";
import { type licenseProductForm_QueryFragment$key } from "@relay/licenseProductForm_QueryFragment.graphql";
import { LicenseProductDataContentKind } from "@relay/ProductTypeColumn_ProductFragment.graphql";
import { type SelectLicenseDefinitionFieldState } from "../../../../features/license-definitions/select-license-definition-field";
import { type ProductFormState } from "../product-form/product-form.types";

export type LicenseProductFormState = {
	licenseDefinition?: SelectLicenseDefinitionFieldState;
	licenseDefinitionAmount?: number;
	contentKind?: string;
} & ProductFormState;

export type LicenseProductFormProps = {
	productFragmentRef: licenseProductForm_LicenseProductFragment$key;
	queryFragmentRef: licenseProductForm_QueryFragment$key;
};

export const contentKindOptions: LicenseProductDataContentKind[] = [
	"CertificationContent",
	"CourseContent",
	"CourseWithCertificationContent",
];
